<nav class="navbar navbar-expand-lg navbar-dark bg-transparent">
  <a class="navbar-brand">Noxe</a>
  <button class="navbar-toggler" type="button" data-toggle="collapse" data-target="#navbarSupportedContent"
    aria-controls="navbarSupportedContent" aria-expanded="false" aria-label="Toggle navigation">
    <span class="navbar-toggler-icon"></span>
  </button>

  <div *ngIf="_NavserfService.isError" class="collapse navbar-collapse" id="navbarSupportedContent">
    <ul class="navbar-nav mr-auto">
      <li class="nav-item">
        <a class="nav-link" *ngIf="isLogin" [routerLinkActive]="'test'" routerLink="home">Home</a>
      </li>
      <li class="nav-item">
        <a class="nav-link" *ngIf="isLogin" [routerLinkActive]="'test'" routerLink="movies">Movies</a>
      </li>

      <li class="nav-item">
        <a class="nav-link" *ngIf="isLogin" [routerLinkActive]="'test'" routerLink="tv">TV Show</a>
      </li>
      <li class="nav-item">
        <a class="nav-link" *ngIf="isLogin" [routerLinkActive]="'test'" routerLink="people">People</a>
      </li>
       <li class="nav-item">
        <a class="nav-link" *ngIf="isLogin" [routerLinkActive]="'test'" routerLink="about">About</a>
      </li>

      <!-- <li class="nav-item">
        <a class="nav-link"  *ngIf="isLogin"  [routerLinkActive]="'test'" routerLink='contacts'>Contacts</a>
      </li> -->

      <!-- <li class="nav-item">
        <a class="nav-link"  *ngIf="isLogin"  [routerLinkActive]="'test'" routerLink='learning'>learning</a>
      </li> -->
    </ul>
    <ul class="navbar-nav ml-auto">
      <li class="nav-item">
        <a class="nav-link" *ngIf="!isLogin" [routerLinkActive]="'test'" routerLink="register">Register</a>
      </li>
      <li class="nav-item">
        <a class="nav-link" *ngIf="!isLogin" [routerLinkActive]="'test'" routerLink="login">Login</a>
      </li>
      <li class="nav-item">
        <!-- <button mat-button [matMenuTriggerFor]="menu" class="pr-3">
          <div class="profile">
            <img class="w-100 rounded-circle" *ngIf="isLogin" src="assets/images/one.jpg" alt="">
          </div>
        </button>
        <mat-menu #menu="matMenu">
          <button mat-menu-item>
            <mat-slide-toggle>Light</mat-slide-toggle>
          </button>
          <button mat-menu-item><a class="nav-link" *ngIf="isLogin" routerLink="/profile">Edit profile</a></button>
             </mat-menu> -->
          <a class="nav-link" *ngIf="isLogin" (click)="logout()" [routerLinkActive]="'test'"><i
                class="fas fa-sign-out-alt"></i> logout</a>

        <!-- <div class="profile">
          <img class="w-100 rounded-circle m-1 pr-1" *ngIf="isLogin" src="assets/images/d.png" alt="">
        </div> -->
      </li>

    </ul>
  </div>
</nav>
